var _mask, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_14656_4492",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 44,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 42,
    height: 44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 21C1 9.95754 9.95169 1 20.9942 1C32.0366 1 40.9883 9.95754 40.9883 21C40.9883 32.0425 32.0366 41 20.9942 41C9.95169 41 1 32.0425 1 21Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.9942C0 9.3994 9.3994 0 20.9942 0C32.5889 0 41.9883 9.3994 41.9883 20.9942H39.9883C39.9883 10.504 31.4843 2 20.9942 2C10.504 2 2 10.504 2 20.9942H0ZM41.9883 23.0058C41.9883 34.6006 32.5889 44 20.9942 44C9.3994 44 0 34.6006 0 23.0058L2 21.0058C2 30.3915 10.504 38 20.9942 38C31.4843 38 39.9883 30.3915 39.9883 21.0058L41.9883 23.0058ZM20.9942 44C9.3994 44 0 34.6006 0 23.0058V20.9942C0 9.3994 9.3994 0 20.9942 0V2C10.504 2 2 10.504 2 20.9942V21.0058C2 30.3915 10.504 38 20.9942 38V44ZM20.9942 0C32.5889 0 41.9883 9.3994 41.9883 20.9942V23.0058C41.9883 34.6006 32.5889 44 20.9942 44V38C31.4843 38 39.9883 30.3915 39.9883 21.0058V20.9942C39.9883 10.504 31.4843 2 20.9942 2V0Z",
    fill: "#90A8C1",
    fillOpacity: 0.3,
    mask: "url(#path-1-outside-1_14656_4492)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9883 21.0007C40.9883 31.102 33.5028 39.4529 23.7786 40.808C22.8694 40.9341 21.9391 41 20.9949 41C19.9049 41 18.8345 40.9131 17.7922 40.7449C8.27111 39.2118 1 30.9548 1 21.0007C1 9.95491 9.9523 1 20.9935 1C32.0346 1 40.9883 9.95491 40.9883 21.0007Z",
    fill: "#1877F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.776 17.0651V21.422H29.1642L28.311 27.2911H23.776V40.8131C22.8668 40.9392 21.9365 41.0051 20.9923 41.0051C19.9023 41.0051 18.8319 40.9182 17.7896 40.7501V27.2911H12.8203V21.422H17.7896V16.0911C17.7896 12.7838 20.4697 10.1016 23.7774 10.1016V10.1044C23.7872 10.1044 23.7956 10.1016 23.8054 10.1016H29.1656V15.1774H25.6631C24.6222 15.1774 23.7774 16.0225 23.7774 17.0637L23.776 17.0651Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareFacebook);
export default __webpack_public_path__ + "static/media/ShareFacebook.3e929fe24686109ac805aaaf96f21428.svg";
export { ForwardRef as ReactComponent };